import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const CheckWrapper = styled.div`
  width: ${props => (props.$width || '20px')};
  height: ${props => (props.$width || '20px')};
  border: solid 2px;
  border-color: ${props => (props.$borderColor || (props.$checked ? colors.primary : colors.black))};
  display: grid;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: ${props => props.$backgroundColor || 'transparent'};
  box-sizing: content-box;
  border-radius: ${props => props.$borderRadius || '0'};
`;

export const CheckMark = styled.span`
  display: inline-block;
  width: 22px;
  height: 22px;
  -ms-transform: rotate(225deg); /* IE 9 */
  -webkit-transform: rotate(225deg); /* Chrome, Safari, Opera */
  transform: rotate(225deg);
`;

export const CheckMarkStem = styled.div`
  position: absolute;
  width: 8px;
  height: 2px;
  background-color: ${props => (props.$fillColor || colors.primary)};
  left: 40%;
  top: 40%;
`;

export const CheckMarkKick = styled.div`
  position: absolute;
  width: 2px;
  height: 10px;
  background-color: ${props => (props.$fillColor || colors.primary)};
  right: 50%;
  top: 40%;
`;
